import React, { useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router';
import { useReports } from '../../modules/Reports';
import { login, LOGIN_STATES, HUBBLE_SESSION_AUTH } from '../../modules/Login';
import Session from '../../modules/Session';
import { LoadingView } from '../../components';
import ErrorPage from '../ErrorPage';
import PlanSponsorReportView from './PlanSponsorReport-view';

const PlanSponsorReportContainer = () => {
  const match = useRouteMatch();
  const reports = useReports();
  const planSponsorReport = reports.planSponsor;
  const [authChecked, setAuthChecked] = useState(false);
  const [authError, setAuthError] = useState(false);

  // Check authentication on mount
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const session = Session.get(HUBBLE_SESSION_AUTH);

        if (
          !session ||
          !session.token ||
          session.loginStatus !== LOGIN_STATES.loggedin
        ) {
          // Not logged in - redirect to OAuth login
          login();
          return;
        }

        setAuthChecked(true);
      } catch (error) {
        console.error('Authentication error:', error);
        setAuthError(true);
      }
    };

    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (authChecked && match.params.planSponsorId) {
      planSponsorReport.dispatch(match.params.planSponsorId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [match.params.planSponsorId, authChecked]);

  const [ManagedParticipants, setManagedParticipantChart] = useState(null);
  const [ManagedAssets, setManagedAssetsChart] = useState(null);
  const [ManagedByDate, setManagedByDate] = useState(null);
  const [ManagedAssetsByDate, setManagedAssetsByDate] = useState(null);
  const [StrategyBreakdown, setStrategyBreakdown] = useState(null);
  const [StrategySummary, setStrategySummary] = useState(null);
  const [InteractionSummary, setInteractionSummary] = useState(null);
  const [GapHired, setGapHired] = useState(null);

  // Handle authentication states
  if (authError) {
    return <ErrorPage />;
  }

  if (!authChecked) {
    return (
      <LoadingView title="Please Wait." message="Loading your account..." />
    );
  }

  const rows =
    planSponsorReport.data &&
    planSponsorReport.data.interactions.length > 0 &&
    Object.keys(planSponsorReport.data.interactions[0]).map((x) => (
      <th key={x}>{x}</th>
    ));

  return (
    planSponsorReport.state === 'LOADED' &&
    planSponsorReport.data != null && (
      <PlanSponsorReportView
        heading="Plan Sponsor Stats"
        report={planSponsorReport.data}
        status={planSponsorReport.state}
        chartImages={{
          ManagedAssets,
          ManagedParticipants,
          ManagedByDate,
          ManagedAssetsByDate,
          StrategyBreakdown,
          StrategySummary,
          InteractionSummary,
          GapHired,
        }}
        data={{
          rows,
        }}
        setter={{
          setManagedAssetsChart,
          setManagedParticipantChart,
          setManagedByDate,
          setManagedAssetsByDate,
          setStrategyBreakdown,
          setStrategySummary,
          setInteractionSummary,
          setGapHired,
        }}
      />
    )
  );
};

export default PlanSponsorReportContainer;
